__turbopack_context__.v({
  "conversation": "_0XS8Ga_conversation",
  "loading": "_0XS8Ga_loading",
  "message": "_0XS8Ga_message",
  "messageAppear": "_0XS8Ga_messageAppear",
  "messageText": "_0XS8Ga_messageText",
  "scrollArea": "_0XS8Ga_scrollArea",
  "skill": "_0XS8Ga_skill",
});
